const $ = jQuery.noConflict();
'use strict';

const MemberPopup = {

	$domUrl: $('body').data('url'),

	init: function() {
		$(window).on('load', ()=>{
			const param = MemberPopup.getUrlParameter('member');
			if (!param) return;
			showPopup(param);
		});
		function showPopup(whichpopup){
			// if not exist popup, exit this function
			if ($(`[data-team-id='${whichpopup}']`).length < 1) return;

			$('.js-overlay-member-popup').addClass('active');
			$('.member-popup-' + whichpopup).addClass('active');
			$('body').addClass('prevent-scroll');

			// push url address
			const url = MemberPopup.$domUrl + '?member=' + whichpopup;
			window.history.pushState('', '', url);
		}
		function closePopup(){
			$('.js-overlay-member-popup').removeClass('active');
			$('.js-member-popup').removeClass('active');
			$('body').removeClass('prevent-scroll');

			// push url address
			window.history.pushState('', '', MemberPopup.$domUrl);
		}
		$('.js-show-member-popup').on('click', function(event){
			event.preventDefault();
			const selectedPopup = $(this).data('modal');
			showPopup(selectedPopup);
		});
		$('.js-close-member-popup, .js-overlay-member-popup').on('click', function() {
			closePopup();
		});
		$(document).on('keyup', function(e) {
			if (e.keyCode === 27) {
				closePopup();
			}
		});
	},
	// get url parameter
	getUrlParameter: (param)=> {
		const url = window.location.search.substring(1);
		const urlVariables = url.split('?');
		let parameterName;

		for (let i = 0; i < urlVariables.length; i++) {
			parameterName = urlVariables[i].split('=');
			if (parameterName[0] === param) return parameterName[1] === undefined ? true : decodeURIComponent(parameterName[1]);
		}
		return false;
	}
};

export default MemberPopup;
